// extracted by mini-css-extract-plugin
export default {"container":"DropLine-module__container--SD7uR","text":"DropLine-module__text--UVeVO","button":"DropLine-module__button--JQpmn"};